import * as React from 'react';

//Custom Controls
import BaseInputControl from './BaseInputControl';

//Types
import { IWholeNumberControlProps } from '@/@types/controls/controls';

function WholeNumberControl(props: IWholeNumberControlProps) {
  const { formMode, controlMode, field, value, onChange, helperText, validation, ...other } = props;

  const { allowNegative } = field;

  const handleChange = (newValue: string | number | null, source: string) => {
    if (typeof newValue === 'string') {
      const trimmed = newValue.trim();

      // Regex: Optional "-" at the start (if allowNegative), followed by one or more digits
      const pattern = allowNegative ? /^-?\d+$/ : /^\d+$/;

      if (trimmed.length === 0) {
        onChange(null, source);
      } else if (pattern.test(trimmed)) {
        const parsed = parseInt(trimmed, 10);
        onChange(parsed, source);
      }
      // Else: ignore invalid input
    } else if (typeof newValue === 'number') {
      if (
        Number.isInteger(newValue) &&
        (allowNegative || newValue >= 0) // allow negative if allowed, otherwise only non-negative
      ) {
        onChange(newValue, source);
      }
    } else {
      onChange(null, source);
    }
  };

  const displayValue = value !== null ? value.toString() : '';

  return <BaseInputControl {...props} value={displayValue} onChange={handleChange} />;
}

export default WholeNumberControl;
